import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "grid place-items-center w-screen h-screen"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("img", {
    class: "w-32 md:w-64",
    src: "/images/logo.png"
}, null, -1);
const _hoisted_3 = [
    _hoisted_2
];
import { useRouter } from "vue-router";
import { useCSRF } from "@/stores/csrf";
import { useAuth } from "@/stores/auth";
import { useFetch } from "@/helpers";
import { flare } from '@flareapp/flare-client';
import { storeToRefs } from "pinia";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Auth',
    setup(__props) {
        const router = useRouter();
        const { getUser } = useAuth();
        const { user } = storeToRefs(useAuth());
        const { initCSRF } = useCSRF();
        const { loading, fetch } = useFetch(async () => {
            // Get a valid CSRF Token
            await initCSRF();
            // Load the user for this session
            await getUser();
            flare.addContextGroup("user", user?.value || {});
        });
        fetch();
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                    (_unref(loading))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
                        : _renderSlot(_ctx.$slots, "default", { key: 1 })
                ]),
                _: 3
            }));
        };
    }
});
